import { useState } from "react";
import AddAttendance from "./AddAttendance";
import ViewTotalAttendance from "./ViewTotalAttendance";
import ViewAttendenceByDate from "./ViewAttendenceByDate";
import { FiPlusCircle, FiCalendar, FiBarChart2 } from "react-icons/fi";

const Attendence = () => {
  const [activeTab, setActiveTab] = useState('add');

  return (
    <div className="w-full space-y-6">
      {/* Header Banner */}
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Attendance Management</h1>
          <p className="text-slate-500 dark:text-slate-400 font-medium text-xs md:text-sm mt-1">Record daily attendance, view history by date, and track total student attendance</p>
        </div>
      </div>

      {/* Sub-tab Navigation */}
      <div className="bento-card p-1.5 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-1.5">
          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "add"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("add")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiPlusCircle className="w-4 h-4" />
              <span>Add Attendance</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "viewDate"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("viewDate")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiCalendar className="w-4 h-4" />
              <span>Attendance By Date</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "view"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("view")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiBarChart2 className="w-4 h-4" />
              <span>View Total Attendance</span>
            </div>
          </button>
        </div>
      </div>

      {/* Active Tab Content */}
      <div className="w-full">
        {activeTab === "add" && <AddAttendance />}
        {activeTab === "viewDate" && <ViewAttendenceByDate />}
        {activeTab === "view" && <ViewTotalAttendance />}
      </div>
    </div>
  );
};

export default Attendence;